import React from 'react'

function DynamicOnboardingForm() {
  return (
    <div>DynamicOnboardingForm</div>
  )
}

export default DynamicOnboardingForm